import React from "react";
import Banner from "./Banner/Banner";
import PastEvents1 from "../../assets/images/gallery-photo1.png";
import PastEvents2 from "../../assets/images/gallery-photo2.png";
import PastEvents3 from "../../assets/images/gallery-photo3.png";
import PastEvents4 from "../../assets/images/gallery-photo4.png";
import PastEvents5 from "../../assets/images/gallery-photo5.png";
import PastEvents6 from "../../assets/images/gallery-photo6.png";

import Video1 from "../../assets/Videos/globe.mp4";

import styles from "./KnowledgeSeriesEvent.module.css";
import Gallery from "./Gallery/Gallery";
import Publications from "./Publications/Publications";
import { similarProfiles } from "../../components/ProfileCard/FullProfile/SimilarProfilesData";

const IMAGES = [
  {
    id: 1,
    type: "image",
    src: PastEvents1,
    thumb: PastEvents1,
    title: "",
  },
  {
    id: 2,
    type: "video",
    src: Video1,
    thumb: PastEvents2,
    title: "",
  },
  {
    id: 3,
    type: "image",
    src: PastEvents3,
    thumb: PastEvents3,
    title: "",
  },
  {
    id: 4,
    type: "image",
    src: PastEvents4,
    thumb: PastEvents4,
    title: "",
  },
  {
    id: 5,
    type: "image",
    src: PastEvents5,
    thumb: PastEvents5,
    title: "",
  },
  {
    id: 6,
    type: "video",
    src: Video1,
    thumb: PastEvents6,
    title: "",
  },
];

const KnowledgeSeriesEvent = () => {
  return (
    <main className={styles.knowledgeSeriesEvent}>
      <Banner />
      <section className={styles.upcoming}>
        <div className={styles.container}>
          <h3>
            Upcoming <span>Events</span>
          </h3>
          <h5>Join our upcoming knowledge series and research events</h5>
          <div className={styles.cards}>
            <div className={styles.card}>
              <div className={styles.tagOuter}>
                <span className={styles.tag}>AI in Healthcare</span>
                <span className={styles.calendar}>&nbsp;</span>
              </div>
              <h4>AI in Healthcare Research Symposium</h4>
              <p>
                Exploring the latest advancements in artificial intelligence
                applications for medical research and patient care
              </p>
              <p className={styles.time}>Virtual Event · 9:00 AM – 5:00 PM IST</p>
              <button className={styles.btn}>Register Now</button>
            </div>

            <div className={styles.card}>
              <div className={styles.tagOuter}>
                <span className={styles.tag}>AI Publications</span>
                <span className={styles.calendar}>&nbsp;</span>
              </div>
              <h4>AI in Healthcare Research Symposium</h4>
              <p>
                Exploring the latest advancements in artificial intelligence
                applications for medical research and patient care
              </p>
              <p className={styles.time}>Virtual Event · 6:00 PM – 9:00 PM IST</p>
              <button className={styles.btn}>Register Now</button>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.calendarSection}>
        <div className={styles.container}>
          <h5>Event Calendar</h5>
          <div className={styles.calendar}>
            <table>
              <thead>
                <tr>
                  <th>Sun</th>
                  <th>Mon</th>
                  <th>Tue</th>
                  <th>Wed</th>
                  <th>Thu</th>
                  <th>Fri</th>
                  <th>Sat</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>31</td>
                  <td>01</td>
                  <td>02</td>
                  <td>03</td>
                  <td>04</td>
                  <td>05</td>
                  <td>06</td>
                </tr>
                <tr>
                  <td>07</td>
                  <td>08</td>
                  <td>09</td>
                  <td>10</td>
                  <td>11</td>
                  <td>12</td>
                  <td>13</td>
                </tr>
                <tr>
                  <td>14</td>
                  <td>15</td>
                  <td>16</td>
                  <td className={styles.highlight}>17</td>
                  <td>18</td>
                  <td>19</td>
                  <td>20</td>
                </tr>
                <tr>
                  <td>21</td>
                  <td className={styles.today}>22</td>
                  <td>23</td>
                  <td>24</td>
                  <td>25</td>
                  <td>26</td>
                  <td>27</td>
                </tr>
                <tr>
                  <td>28</td>
                  <td>29</td>
                  <td>30</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className={styles.pastEvents}>
        <div className={styles.container}>
          <h3>
            Past Events <span className={styles.highlight}>& Outcomes</span>
          </h3>
          <h5>
            Explore reports, toolkits, videos, and digests from our successful
            events
          </h5>

          <div className={styles.cards}>
            <div className={styles.card}>
              <figure>
                <img src={PastEvents1} alt="Events" />
              </figure>
              <h4>Research Methodology Workshop 2023</h4>
              <p>
                Comprehensive workshop on advanced research methodologies and
                statistical analysis
              </p>
              <div className={styles.tagOuter}>
                <span className={styles.tag}>Report</span>
                <span className={styles.tag}>Toolkit</span>
                <span className={styles.tag}>Video</span>
              </div>
              <button className={styles.viewBtn}>View Resources</button>
            </div>

            <div className={styles.card}>
              <figure>
                <img src={PastEvents2} alt="Events" />
              </figure>
              <h4>Climate Innovation Summit 2023</h4>
              <p>
                Global summit on climate change solutions and sustainable
                technologies
              </p>
              <div className={styles.tagOuter}>
                <span className={styles.tag}>Report</span>
                <span className={styles.tag}>Toolkit</span>
                <span className={styles.tag}>Video</span>
              </div>
              <button className={styles.viewBtn}>View Resources</button>
            </div>

            <div className={styles.card}>
              <figure>
                <img src={PastEvents3} alt="Events" />
              </figure>
              <h4>AI Ethics Conference 2023</h4>
              <p>
                International conference on ethical considerations in artificial
                intelligence
              </p>
              <div className={styles.tagOuter}>
                <span className={styles.tag}>Report</span>
                <span className={styles.tag}>Toolkit</span>
                <span className={styles.tag}>Video</span>
              </div>
              <button className={styles.viewBtn}>View Resources</button>
            </div>
          </div>
        </div>
      </section>
      <section className={styles.gallery}>
        <div className={styles.container}>
          <h3>
            Event Photo <span className={styles.highlight}>/ Video Gallery</span>
          </h3>
          <p>
            Visual moments from IMPRAC’s knowledge series, governance meetings,
            and transformative events
          </p>
          <Gallery images={IMAGES} />
        </div>
      </section>
      <section className={styles.publications}>
        <div className={styles.container}>
          <h3>
            Publications <span className={styles.highlight}>from Events</span>
          </h3>
          <h5>
            Proceedings, special issues, and ISBN books from our knowledge series
          </h5>
          <div className={styles.container}>
            <Publications profiles={similarProfiles} />
          </div>
        </div>
      </section>
    </main>
  );
};

export default KnowledgeSeriesEvent;
